export default "__VITE_ASSET__cogUxIUc__"